import React from 'react';
import { FormatDateOptions, injectIntl, IntlShape } from 'react-intl';

import { RenderOnClient } from '../RenderOnClient';
import { isCurrentDay, isCurrentYear, isWithinLastWeek } from './helpers/dateHelpers';

interface TimestampProps {
    timestamp: string;
    abbreviate: boolean;
}

class Timestamp extends React.Component<TimestampProps & { intl: IntlShape }> {
    render() {
        return (
            <RenderOnClient fallback={null}>
                {this.getTimeMessage(this.props.timestamp)}
            </RenderOnClient>
        );
    }

    getTimeMessage(timestamp: string) {
        if (!Date.parse(timestamp)) return null;
        return (
            <span title={this.getAbsoluteDateString(timestamp)}>
                {this.props.intl.formatDate(timestamp, this.getOptions(new Date(timestamp)))}
            </span>
        );
    }

    getOptions(date: Date): FormatDateOptions {
        const { abbreviate } = this.props;

        if (isCurrentDay(date)) {
            return {
                hour: 'numeric',
                minute: 'numeric',
            };
        }

        if (isWithinLastWeek(date)) {
            return {
                weekday: 'short',
                ...(!abbreviate && { hour: 'numeric', minute: 'numeric' }),
            };
        }

        if (isCurrentYear(date)) {
            return {
                day: 'numeric',
                month: 'short',
                ...(!abbreviate && { hour: 'numeric', minute: 'numeric' }),
            };
        }

        return {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            ...(!abbreviate && { hour: 'numeric', minute: 'numeric' }),
        };
    }

    getAbsoluteDateString(timestamp: string) {
        const format: FormatDateOptions = {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false,
            timeZoneName: 'short',
        };

        return this.props.intl.formatDate(timestamp, format);
    }
}

export default injectIntl(Timestamp);
